var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('enter-header',{attrs:{"page-name":_vm.hdText}}),_vm._v(" "),(_vm.getEnterDetail.data)?[(_vm.getEnterDetail.data.length > 0)?_c('enter-list',{attrs:{"list":_vm.getEnterDetail.data}}):_c('not-found-msg')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }